import { AWSGenericRegionName, AWSRegionCity, AWSRegionName, AWSRegionShortName } from '@enums/aws-regions.enum';
import { GenesysCloudAPIRegionGroup } from '@enums/genesys-cloud-region-group.enum';

export interface GenesysCloudAPIRegion {
  short: string;
  label: string;
  aws: string;
  awsGenericRegion: string;
  auth: string;
  api: string;
  apps: string;
  env: string;
  group: GenesysCloudAPIRegionGroup;
}

export const US_EAST_1: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.US_EAST_NORTH_VIRGINIA,
  awsGenericRegion: AWSGenericRegionName.US_EAST_NORTH_VIRGINIA,
  label: AWSRegionCity.US_EAST_NORTH_VIRGINIA,
  aws: AWSRegionName.US_EAST_NORTH_VIRGINIA,
  auth: 'https://login.mypurecloud.com',
  api: 'https://api.mypurecloud.com',
  apps: 'https://apps.mypurecloud.com',
  env: 'mypurecloud.com',
  group: GenesysCloudAPIRegionGroup.Americas,
};

// NOTE: Disable this for now since the FedRamp requires a separate client id to authenticate
export const US_EAST_2: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.US_EAST_2_OHIO,
  awsGenericRegion: AWSGenericRegionName.US_EAST_2_OHIO,
  label: AWSRegionCity.US_EAST_2_OHIO,
  aws: AWSRegionName.US_EAST_2_OHIO,
  auth: 'https://login.use2.us-gov-pure.cloud',
  api: 'https://api.use2.us-gov-pure.cloud',
  apps: 'https://apps.use2.us-gov-pure.cloud',
  env: 'use2.us-gov-pure.cloud',
  group: GenesysCloudAPIRegionGroup.Americas,
};

export const US_WEST_2: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.US_WEST_OREGON,
  awsGenericRegion: AWSGenericRegionName.US_WEST_OREGON,
  label: AWSRegionCity.US_WEST_OREGON,
  aws: AWSRegionName.US_WEST_OREGON,
  auth: 'https://login.usw2.pure.cloud',
  api: 'https://api.usw2.pure.cloud',
  apps: 'https://apps.usw2.pure.cloud',
  env: 'usw2.pure.cloud',
  group: GenesysCloudAPIRegionGroup.Americas,
};

export const CA_CENTRAL_1_CANADA: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.CANADA_CENTRAL,
  awsGenericRegion: AWSGenericRegionName.CANADA_CENTRAL,
  label: AWSRegionCity.CANADA_CENTRAL,
  aws: AWSRegionName.CANADA_CENTRAL,
  auth: 'https://login.cac1.pure.cloud',
  api: 'https://api.cac1.pure.cloud',
  apps: 'https://apps.cac1.pure.cloud',
  env: 'cac1.pure.cloud',
  group: GenesysCloudAPIRegionGroup.Americas,
};

export const EU_WEST_1_EUROPE: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.EUROPE_IRELAND,
  awsGenericRegion: AWSGenericRegionName.EUROPE_IRELAND,
  label: AWSRegionCity.EUROPE_IRELAND,
  aws: AWSRegionName.EUROPE_IRELAND,
  auth: 'https://login.mypurecloud.ie',
  api: 'https://api.mypurecloud.ie',
  apps: 'https://apps.mypurecloud.ie',
  env: 'mypurecloud.ie',
  group: GenesysCloudAPIRegionGroup.Europe,
};

export const EU_WEST_2_EUROPE: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.EUROPE_LONDON,
  awsGenericRegion: AWSGenericRegionName.EUROPE_LONDON,
  label: AWSRegionCity.EUROPE_LONDON,
  aws: AWSRegionName.EUROPE_LONDON,
  auth: 'https://login.euw2.pure.cloud',
  api: 'https://api.euw2.pure.cloud',
  apps: 'https://apps.euw2.pure.cloud',
  env: 'euw2.pure.cloud',
  group: GenesysCloudAPIRegionGroup.Europe,
};

export const EU_CENTRAL_1_EUROPE: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.EUROPE_FRANKFURT,
  awsGenericRegion: AWSGenericRegionName.EUROPE_FRANKFURT,
  label: AWSRegionCity.EUROPE_FRANKFURT,
  aws: AWSRegionName.EUROPE_FRANKFURT,
  auth: 'https://login.mypurecloud.de',
  api: 'https://api.mypurecloud.de',
  apps: 'https://apps.mypurecloud.de',
  env: 'mypurecloud.de',
  group: GenesysCloudAPIRegionGroup.Europe,
};

export const EU_CENTRAL_2_EUROPE: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.EUROPE_ZURICH,
  awsGenericRegion: AWSGenericRegionName.EUROPE_ZURICH,
  label: AWSRegionCity.EUROPE_ZURICH,
  aws: AWSRegionName.EUROPE_ZURICH,
  auth: 'https://login.euc2.pure.cloud',
  api: 'https://api.euc2.pure.cloud',
  apps: 'https://apps.euc2.pure.cloud',
  env: 'euc2.pure.cloud',
  group: GenesysCloudAPIRegionGroup.Europe,
};

export const ME_CENTRAL_1_MIDDLE_EAST: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.MIDDLE_EAST_UAE,
  awsGenericRegion: AWSGenericRegionName.MIDDLE_EAST_UAE,
  label: AWSRegionCity.MIDDLE_EAST_UAE,
  aws: AWSRegionName.MIDDLE_EAST_UAE,
  auth: 'https://login.mec1.pure.cloud',
  api: 'https://api.mec1.pure.cloud',
  apps: 'https://apps.mec1.pure.cloud',
  env: 'mec1.pure.cloud',
  group: GenesysCloudAPIRegionGroup.MiddleEast,
};

export const AP_SOUTH_1_ASIA_PACIFIC: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.ASIA_PACIFIC_MUMBAI,
  awsGenericRegion: AWSGenericRegionName.ASIA_PACIFIC_MUMBAI,
  label: AWSRegionCity.ASIA_PACIFIC_MUMBAI,
  aws: AWSRegionName.ASIA_PACIFIC_MUMBAI,
  auth: 'https://login.aps1.pure.cloud',
  api: 'https://api.aps1.pure.cloud',
  apps: 'https://apps.aps1.pure.cloud',
  env: 'aps1.pure.cloud',
  group: GenesysCloudAPIRegionGroup.AsiaPacific,
};

export const AP_NORTH_EAST_1_ASIA_PACIFIC: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.ASIA_PACIFIC_TOKYO,
  awsGenericRegion: AWSGenericRegionName.ASIA_PACIFIC_TOKYO,
  label: AWSRegionCity.ASIA_PACIFIC_TOKYO,
  aws: AWSRegionName.ASIA_PACIFIC_TOKYO,
  auth: 'https://login.mypurecloud.jp',
  api: 'https://api.mypurecloud.jp',
  apps: 'https://apps.mypurecloud.jp',
  env: 'mypurecloud.jp',
  group: GenesysCloudAPIRegionGroup.AsiaPacific,
};

export const AP_NORTH_EAST_2_ASIA_PACIFIC: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.ASIA_PACIFIC_SEOUL,
  awsGenericRegion: AWSGenericRegionName.ASIA_PACIFIC_SEOUL,
  label: AWSRegionCity.ASIA_PACIFIC_SEOUL,
  aws: AWSRegionName.ASIA_PACIFIC_SEOUL,
  auth: 'https://login.apne2.pure.cloud',
  api: 'https://api.apne2.pure.cloud',
  apps: 'https://apps.apne2.pure.cloud',
  env: 'apne2.pure.cloud',
  group: GenesysCloudAPIRegionGroup.AsiaPacific,
};

export const AP_NORTH_EAST_3_ASIA_PACIFIC: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.ASIA_PACIFIC_OSAKA,
  awsGenericRegion: AWSGenericRegionName.ASIA_PACIFIC_OSAKA,
  label: AWSRegionCity.ASIA_PACIFIC_OSAKA,
  aws: AWSRegionName.ASIA_PACIFIC_OSAKA,
  auth: 'https://login.apne3.pure.cloud',
  api: 'https://api.apne3.pure.cloud',
  apps: 'https://apps.apne3.pure.cloud',
  env: 'apne3.pure.cloud',
  group: GenesysCloudAPIRegionGroup.AsiaPacific,
};

export const AP_SOUTH_EAST_2_ASIA_PACIFIC: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.ASIA_PACIFIC_SYDNEY,
  awsGenericRegion: AWSGenericRegionName.ASIA_PACIFIC_SYDNEY,
  label: AWSRegionCity.ASIA_PACIFIC_SYDNEY,
  aws: AWSRegionName.ASIA_PACIFIC_SYDNEY,
  auth: 'https://login.mypurecloud.com.au',
  api: 'https://api.mypurecloud.com.au',
  apps: 'https://apps.mypurecloud.com.au',
  env: 'mypurecloud.com.au',
  group: GenesysCloudAPIRegionGroup.AsiaPacific,
};

export const AP_EAST_1_SOUTH_AMERICA: GenesysCloudAPIRegion = {
  short: AWSRegionShortName.SOUTH_AMERICA_SAO_PAULO,
  awsGenericRegion: AWSGenericRegionName.SOUTH_AMERICA_SAO_PAULO,
  label: AWSRegionCity.SOUTH_AMERICA_SAO_PAULO,
  aws: AWSRegionName.SOUTH_AMERICA_SAO_PAULO,
  auth: 'https://login.sae1.pure.cloud',
  api: 'https://api.sae1.pure.cloud',
  apps: 'https://apps.sae1.pure.cloud',
  env: 'sae1.pure.cloud',
  group: GenesysCloudAPIRegionGroup.Americas,
};

export const GenesysCloudAPI = [
  US_EAST_1,
  US_WEST_2,
  CA_CENTRAL_1_CANADA,
  EU_WEST_1_EUROPE,
  EU_WEST_2_EUROPE,
  EU_CENTRAL_1_EUROPE,
  EU_CENTRAL_2_EUROPE,
  ME_CENTRAL_1_MIDDLE_EAST,
  AP_SOUTH_1_ASIA_PACIFIC,
  AP_NORTH_EAST_1_ASIA_PACIFIC,
  AP_NORTH_EAST_2_ASIA_PACIFIC,
  AP_NORTH_EAST_3_ASIA_PACIFIC,
  AP_SOUTH_EAST_2_ASIA_PACIFIC,
  AP_EAST_1_SOUTH_AMERICA,
];
